import { Component, ChangeDetectionStrategy, inject, input, linkedSignal } from '@angular/core';

import {GestionService} from "../../Services/gestion.service";
import {ToastrService} from "ngx-toastr";
import {ModalService} from "../../Services/modal.service";

@Component({
    selector: 'mk-green-action-button',
    imports: [],
    templateUrl: './green-action-button.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './green-action-button.component.scss'
})
export class GreenActionButtonComponent {
  gestion = inject(GestionService);
  toast = inject(ToastrService);
  modal = inject(ModalService);


  /**
   * Thème du bouton
   */
  readonly theme = input<"dark" | "light">("light");


  readonly enabled = input.required<boolean>();
  /**
   * Label du bouton
   */
  readonly baseLabel = input.required<string>();

  readonly baseIcon = input.required<string>();

  /** Handler appelé avec `this` = instance du bouton */
  readonly callback = input<() => void>(() => {});

  /** État initial pilotable depuis le parent via [_state] */
  readonly _stateInput = input<"default" | "loading" | "success" | "failed">("default", { alias: "_state" });

  readonly _state = linkedSignal(() => this._stateInput());

  /** Label affiché : suit baseLabel, surchargeable par les handlers */
  readonly _displayedLabel = linkedSignal(() => this.baseLabel());

  readonly data = input<any>({});

  getIconFromState(): string {
    switch(this._state()){
      case "default":
        return this.baseIcon();
      case "loading":
        return "progress_activity";
      case "success":
        return "done_all";
      case "failed":
        return "error";
    }
  }

  reset(){
    this._state.set("default");
    this._displayedLabel.set(this.baseLabel());
  }

  call() {
    if(this._state() !== "default")return;
    if(!this.enabled())return;
    this.callback().call(this);
  }
}
